import { Button, Grid, Popover, Tooltip, Typography } from "@material-ui/core";
import { formatMoney, getDateTime } from "app/common/LocalFunction";
import { useStore } from "app/stores";
import { observer } from "mobx-react";
import React, { memo, useEffect, useState } from "react";
import {
  VOUCHER_INVOICE_TYPE,
  VOUCHER_INVOICE_TYPE_REPORT_DETAIL,
  VOUCHER_TYPE_VALUE,
} from "app/common/LocalConst";
import GlobitsPagination from "app/common/Component/Table/Pagination";
import history from "history.js";
import { PAYMENT_METHOD_LIMITS } from "app/appConfig";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import { CopyableCodeCell } from "utils";
import { useStylesExtraButton } from "app/common/Component/Table/TableComponent";
import { PhoneNumberCell } from "utils";
const ReportPaymentList = () => {
  const {
    listData,
    dataPayment,
    searchReportVoucher,
    handleChangeFormSearchVoucher,
    handleOpenPopupReportDetail,
  } = useStore().patientManagementStore.reportPaymentStore;
  const { getDataDetailVoucher } = useStore().feeStore.serviceFeeTabStore;
  const columns = {
    stt: "STT",
    voucherDate: "Thời gian tạo phiếu",
    accountant: "Thu ngân",
    code: "Mã phiếu",
    displayName: "Mã - Tên KH",
    phoneNumber: "Số điện thoại",
    department: "Cơ sở",
    voucherInvoiceType: "Loại phiếu",
    currentPatientSource: "Nguồn khách tới CS",
    totalRevenue: "Tổng tiền tính doanh thu",
    totalNonRevenue: "Tổng tiền không tính doanh thu",
    totalInstallmentFee: "Tổng phí",
    totalRevenueAfterFee: "Tổng doanh thu trừ phí",
    moneyAfterDiscount: "Tổng",
    note: "Ghi chú",
  };

  const dataInitColumn = {
    stt: true,
    voucherDate: true,
    accountant: true,
    code: true,
    displayName: true,
    phoneNumber: true,
    department: true,
    voucherInvoiceType: true,
    currentPatientSource: true,
    totalRevenue: true,
    totalNonRevenue: true,
    totalInstallmentFee: true,
    totalRevenueAfterFee: true,
    moneyAfterDiscount: true,
    note: true,
  };

  const [visibleColumns, setVisibleColumns] = useState(dataInitColumn);
  const [dynamicColumns, setDynamicColumns] = useState(columns);

  useEffect(() => {
    const dataShowTable =
      JSON.parse(localStorage.getItem("dataTableReportPaymentCustom")) || {};

    const paymentColumns = {};
    const paymentVisibleColumns = {};

    //  Thêm các cột PTTT động
    dataPayment?.content?.forEach((method) => {
      paymentColumns[`payment_${method.code}`] = method.name;
      paymentVisibleColumns[`payment_${method.code}`] = true;
    });

    // Merge tất cả cột trừ ghi chú
    const baseColumnsWithoutNote = { ...columns };
    delete baseColumnsWithoutNote.note;

    const allColumns = { ...baseColumnsWithoutNote, ...paymentColumns, note: "Ghi chú" };
    const allVisibleColumns = { ...dataInitColumn, ...paymentVisibleColumns };

    setDynamicColumns(allColumns);

    // Nếu chưa có localStorage, tạo mới
    if (Object.keys(dataShowTable).length === 0) {
      setVisibleColumns(allVisibleColumns);
      localStorage.setItem(
        "dataTableReportPaymentCustom",
        JSON.stringify(allVisibleColumns)
      );
    } else {
      // Nếu đã có, merge thêm cột PTTT
      const mergedVisible = { ...allVisibleColumns, ...dataShowTable };
      // Đảm bảo "note" nằm cuối
      const { note, ...rest } = mergedVisible;
      const reorderedVisible = { ...rest, note };

      setVisibleColumns(reorderedVisible);
      localStorage.setItem(
        "dataTableReportPaymentCustom",
        JSON.stringify(reorderedVisible)
      );
    }
  }, [dataPayment]);

  // Filter payment methods based on PAYMENT_METHOD_LIMITS
  const filteredPaymentMethods = dataPayment?.content?.filter(
    (method) =>
      !Array.isArray(PAYMENT_METHOD_LIMITS) ||
      PAYMENT_METHOD_LIMITS.length === 0 ||
      !PAYMENT_METHOD_LIMITS.includes(method.code)
  );

  console.log("🚀 ~ ReportPaymentList ~ dataPayment:", dataPayment);
  return (
    <>
      <section className="cards-container">
        <h4 className="cards-header">
          Báo cáo thu chi theo hình thức thanh toán
        </h4>
        <Grid container spacing={1} className="w-100 m-0">
          <Grid item xs={12}>
            <div className="flex justify-end">
              <ExtraButton
                setVisibleColumns={setVisibleColumns}
                visibleColumns={visibleColumns}
                columns={dynamicColumns}
              />
            </div>
            <div className="table-scroll-wrapper">
              <table className="report-table">
                <thead>
                  <tr>
                    {visibleColumns.stt && <th>STT</th>}
                    {visibleColumns.voucherDate && <th>Thời gian tạo phiếu</th>}
                    {visibleColumns.accountant && <th>Thu ngân</th>}
                    {visibleColumns.code && <th>Mã phiếu</th>}
                    {visibleColumns.displayName && <th>Mã - Tên KH</th>}
                    {visibleColumns.phoneNumber && <th>Số điện thoại</th>}
                    {visibleColumns.department && <th>Cơ sở</th>}
                    {/* <th>Nguồn hiện tại</th> */}
                    {visibleColumns.voucherInvoiceType && <th>Loại phiếu</th>}
                    {visibleColumns.currentPatientSource && (
                      <th>Nguồn khách tới CS</th>
                    )}
                    {visibleColumns.totalRevenue && (
                      <th>Tổng tiền tính doanh thu</th>
                    )}
                    {visibleColumns.totalNonRevenue && (
                      <th>Tổng tiền không tính doanh thu</th>
                    )}
                    {visibleColumns.totalInstallmentFee && (
                      <th>Tổng phí</th>
                    )}
                    {visibleColumns.totalRevenueAfterFee && (
                      <th>Tổng doanh thu trừ phí</th>
                    )}
                    {visibleColumns.moneyAfterDiscount && <th>Tổng</th>}

                    {filteredPaymentMethods?.map(
                      (method, index) =>
                        visibleColumns[`payment_${method.code}`] && (
                          <th key={index}>{method.name}</th>
                        )
                    )}

                    {visibleColumns.note && <th>Ghi chú</th>}
                  </tr>
                </thead>
                <tbody>
                  <tr className="total-row">

                    {/* Đoạn này là tính cột để ẩn đến cột, đến cột tổng là ẩn Luôn cái text Tổng đi */}
                    {(() => {
                      // Danh sách cột xuất hiện trước khi đến cột tổng
                      const beforeTotalCols = [
                        "stt",
                        "voucherDate",
                        "accountant",
                        "code",
                        "displayName",
                        "phoneNumber",
                        "department",
                        "voucherInvoiceType",
                        "currentPatientSource",
                      ];
                      // Đếm số cột đang bật
                      const colSpanCount = beforeTotalCols.filter(
                        (key) => visibleColumns[key]
                      ).length;
                      // Nếu không còn cột nào hiển thị => không render ô "TỔNG"
                      if (colSpanCount === 0) return null;
                      return (
                        <td
                          colSpan={colSpanCount}
                          style={{ fontWeight: "bold", textAlign: "left" }}
                        >
                          TỔNG:
                        </td>
                      );
                    })()}

                    {visibleColumns.totalRevenue && (
                      <td style={{ color: "#d9534f", fontWeight: "bold" }}>
                        {formatMoney(listData?.subTotalRevenue)}
                      </td>
                    )}
                    {visibleColumns.totalNonRevenue && (
                      <td>{formatMoney(listData?.subTotalNonRevenue)}</td>
                    )}
                    {visibleColumns.totalInstallmentFee && (
                      <td>{formatMoney(listData?.subTotalInstallmentFee)}</td>
                    )}
                    {visibleColumns.totalRevenueAfterFee && (
                      <td style={{ fontWeight: "bold" }}>
                        {formatMoney(listData?.subTotalRevenueAfterFee)}
                      </td>
                    )}
                    {visibleColumns.moneyAfterDiscount && (
                      <td>{formatMoney(listData?.subTotalAmount)}</td>
                    )}
                    {filteredPaymentMethods?.map(
                      (method, index) =>
                        visibleColumns[`payment_${method.code}`] && (
                          <td key={index}>
                            {formatMoney(
                              listData?.paymentMethodTotals?.find(
                                (x) =>
                                  x.codePaymentMethodValue === method.code
                              )?.total || "0"
                            )}
                          </td>
                        )
                    )}
                    {visibleColumns.note && <td></td>}
                  </tr>

                  {listData?.content?.map((item, index) => (
                    <tr key={index}>
                      {visibleColumns.stt && <td>{index + 1}</td>}
                      {visibleColumns.voucherDate && (
                        <td>{getDateTime(item?.voucherDate)}</td>
                      )}
                      {visibleColumns.accountant && (
                        <td>{item?.accountant?.staffName}</td>
                      )}
                      {visibleColumns.code && (
                        <td onClick={() => getDataDetailVoucher(item)}>
                          {item?.code || "Không có mã"}
                        </td>
                      )}
                      {visibleColumns.displayName && (
                        <td>
                          <div
                            onClick={() => {
                              window.open(
                                `/patient-management/patient-general?patientId=${item?.patient?.id}`,
                                "_blank"
                              );
                            }}
                          >
                            <div>
                              <p>
                                <b>{item?.patient?.displayName}</b>
                              </p>
                              <p className="flex">
                                <b style={{ color: "#4276a4" }}>
                                  <CopyableCodeCell value={item?.patient?.code} size="small" />{" "}
                                </b>
                              </p>
                            </div>
                          </div>
                        </td>
                      )}
                      {visibleColumns.phoneNumber && (
                        <td>
                          <PhoneNumberCell value={item?.patient?.phoneNumber} />
                        </td>
                      )}
                      {visibleColumns.department && (
                        <td>{item?.department?.name}</td>
                      )}
                      {visibleColumns.voucherInvoiceType && (
                        <td>
                          {
                            VOUCHER_INVOICE_TYPE?.find(
                              (t) => t.value === item?.voucherInvoiceType
                            )?.name
                          }
                        </td>
                      )}

                      {visibleColumns.currentPatientSource && (
                        <td>{item?.currentPatientSource?.name}</td>
                      )}

                      {/* Tổng tiền tính doanh thu */}
                      {visibleColumns.totalRevenue && (
                        <td style={{ color: "#d9534f" }}>
                          {formatMoney(item?.totalRevenue)}
                        </td>
                      )}

                      {/* Tổng tiền không tính doanh thu */}
                      {visibleColumns.totalNonRevenue && (
                        <td>
                          {formatMoney(item?.totalNonRevenue)}
                        </td>
                      )}

                      {/* Tổng phí */}
                      {visibleColumns.totalInstallmentFee && (
                        <td>
                          {formatMoney(item?.totalInstallmentFee)}
                        </td>
                      )}

                      {/* Tổng doanh thu trừ phí */}
                      {visibleColumns.totalRevenueAfterFee && (
                        <td style={{ fontWeight: "bold" }}>
                          {formatMoney((item?.totalRevenue || 0) - (item?.totalInstallmentFee || 0))}
                        </td>
                      )}

                      {/* Tổng */}
                      {visibleColumns.moneyAfterDiscount && (
                        <td>
                          {item.moneyAfterDiscount?.toLocaleString("vi-VN")}
                        </td>
                      )}

                      {/* PTTT */}
                      {filteredPaymentMethods?.map((method, index) => {
                        const match = item?.voucherPaymentMethods?.find(
                          (x) => x?.paymentMethodValue?.code === method.code
                        );
                        if (!visibleColumns[`payment_${method.code}`]) return null;
                        return (
                          <td key={index}>
                            {formatMoney(match ? match.totalOfMethod : "0")}
                          </td>
                        );
                      })}

                      {visibleColumns.note && <td>{item.note}</td>}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <GlobitsPagination
              pageIndex={searchReportVoucher.pageIndex}
              pageSize={searchReportVoucher.pageSize}
              totalElements={listData?.totalElements}
              totalPages={Math.ceil(
                listData?.totalElements / listData?.pageSize
              )}
              setPageIndex={(pageIndex) =>
                handleChangeFormSearchVoucher({ pageIndex })
              }
              setPageSize={(pageSize) =>
                handleChangeFormSearchVoucher({ pageSize })
              }
            />
          </Grid>
        </Grid>
      </section >
    </>
  );
};

const ExtraButton = ({ setVisibleColumns, visibleColumns, columns }) => {
  const classes = useStylesExtraButton();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const visibleColumnsFormat = Object.entries(visibleColumns);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const id = !!anchorEl ? "simple-popover" : undefined;
  const onToggle = (index, state) => {
    let newArr = visibleColumnsFormat?.map((el, ind) => {
      if (ind === index) return [el[0], state];
      else return el;
    });
    const obj = Object.fromEntries(newArr);
    setVisibleColumns(obj);

    localStorage.setItem("dataTableReportPaymentCustom", JSON.stringify(obj));
    return newArr;
  };

  return (
    <div>
      <Button
        aria-describedby={id}
        variant="contained"
        color="primary"
        onClick={handleClick}
        className="extra-button-table"
      >
        <div className="flex align-center justify-between">
          {"Xem thêm"}
          <Tooltip title="Xem thêm">
            {!!anchorEl ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
          </Tooltip>
        </div>
      </Button>
      <Popover
        id={id}
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Typography className={classes.typography}>
          {visibleColumnsFormat &&
            visibleColumnsFormat?.map((el, index) => (
              <CustomToggle el={el} onToggle={onToggle} index={index} columns={columns} />
            ))}
        </Typography>
      </Popover>
    </div>
  );
};

const CustomToggle = ({ onToggle, el, index, columns }) => {
  const [active, setActive] = useState(el[1]);

  const handleClick = (index) => {
    setActive((prev) => !prev);
    if (onToggle) {
      onToggle(index, !active);
    }
  };

  return (
    <div className="flex gap-2 align-center toggle-wraper">
      <div className="toggle-container">
        <div
          className={`custom-toggle ${active ? "active" : ""}`}
          onClick={() => handleClick(index)}
        >
          <div className="toggle-circle" />
        </div>
        <div className="flex justify-between align-center" style={{ flex: 1 }}>
          <span className="toggle-label">{columns[el[0]]}</span>
        </div>
      </div>
    </div>
  );
};

export default memo(observer(ReportPaymentList));
